import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialAppModule } from 'src/app/material.module';
import { ContentGenerationCanvasComponent } from './content-generation-canvas.component';
import { CanvasService } from './canvas.service';
import { CanvasChatComponent } from './canvas-chat/canvas-chat.component';
import { CanvasChatItemComponent } from './canvas-chat/canvas-chat-item/canvas-chat-item.component';
import { CanvasSessionsComponent } from './canvas-sessions/canvas-sessions.component';
import { CanvasChatFeedbackDialogComponent } from './canvas-chat/canvas-chat-feedback-dialog/canvas-chat-feedback-dialog.component';
import { CanvasCitationsComponent } from './canvas-citations/canvas-citations.component';
import { ChatIntroductionComponent } from './chat-introduction/chat-introduction.component';
import { CanvasContentEditorComponent } from './canvas-content-editor/canvas-content-editor.component';
import { AddChatDocumentsDialogComponent } from './add-chat-documents-dialog/add-chat-documents-dialog.component';
import { CanvasLoaderComponent } from './canvas-loader/canvas-loader.component';
import { CanvasCustomActionDialogComponent } from './canvas-custom-action-dialog/canvas-custom-action-dialog.component';
import { CanvasApiHandlerService } from './canvas-api-handler.service';
import { ChatSocketService } from './canvas-socket.service';
import { CanvasDocumentDetailsComponent } from './canvas-citations/canvas-document-details/canvas-document-details.component';
import { CanvasSessionShareDialogComponent } from './canvas-session-share-dialog/canvas-session-share-dialog.component';
import { SectionAutocompleteComponent } from './section-autocomplete/section-autocomplete.component';
import { CanvasAuthImageDirective } from './canvas-auth-image.directive';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CanvasHelperService } from './canvas-helper.service';

@NgModule({
  declarations: [
    CanvasChatComponent,
    CanvasLoaderComponent,
    CanvasChatItemComponent,
    CanvasSessionsComponent,
    CanvasCitationsComponent,
    ChatIntroductionComponent,
    CanvasContentEditorComponent,
    SectionAutocompleteComponent,
    CanvasDocumentDetailsComponent,
    AddChatDocumentsDialogComponent,
    ContentGenerationCanvasComponent,
    CanvasChatFeedbackDialogComponent,
    CanvasCustomActionDialogComponent,
    CanvasSessionShareDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialAppModule,
    CanvasAuthImageDirective,
    ScrollingModule,
  ],
  providers: [
    CanvasService,
    ChatSocketService,
    CanvasApiHandlerService,
    CanvasHelperService,
  ],
  exports: [ContentGenerationCanvasComponent, CanvasAuthImageDirective],
})
export class CanvasModule {}
